export default "__VITE_ASSET__CcBcf3gK__"